import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { PLANS_CONFIG, PRO_MONTHLY_USD, PLAN_COMPARISON } from '../config/plans';

const Plans = () => {
  const free = PLANS_CONFIG.free;
  const pro = PLANS_CONFIG.pro;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-cyan-50/40">
      <section className="py-10 md:py-14">
        <div className="mx-auto w-full max-w-5xl px-4 sm:px-6 lg:px-8">
          <div className="mb-10 text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-800/80">Pricing</p>
            <h1 className="mt-2 text-3xl font-bold text-slate-900 md:text-4xl">Simple pricing for contractors who want to stay organized.</h1>
            <p className="mx-auto mt-3 max-w-2xl text-sm text-slate-600 md:text-base">
              Free includes professional quotes, clients, and downloadable PDFs. Pro adds project workspaces, a team member
              portal (up to 2 seats), email delivery from Devello, material search, and job cost tools for{' '}
              <strong>${PRO_MONTHLY_USD}/month</strong>, billed securely through Stripe.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            <div className="flex flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
              <h2 className="text-lg font-bold text-slate-900">{free.name}</h2>
              <p className="mt-1 text-3xl font-black text-slate-900">
                {free.price}
                <span className="text-base font-medium text-slate-500">{free.period}</span>
              </p>
              <p className="mt-3 text-sm text-slate-600">{free.subtitle}</p>
              <ul className="mt-6 flex-1 space-y-2 text-sm text-slate-700">
                {free.features.map((f) => (
                  <li key={f} className="flex gap-2">
                    <span className="text-emerald-600">✓</span>
                    {f}
                  </li>
                ))}
              </ul>
              <Link to="/account?signup=1&plan=free" className="mt-8 block">
                <button
                  type="button"
                  className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-900 hover:bg-slate-50"
                >
                  Get started on Free
                </button>
              </Link>
            </div>

            <div className="relative flex flex-col rounded-2xl border-2 border-primary bg-white p-6 shadow-md">
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-primary px-3 py-1 text-xs font-bold text-white">
                Most popular
              </span>
              <h2 className="text-lg font-bold text-slate-900">{pro.name}</h2>
              <p className="mt-1 text-3xl font-black text-primary">
                {pro.price}
                <span className="text-base font-medium text-slate-600">{pro.period}</span>
              </p>
              <p className="mt-3 text-sm text-slate-600">{pro.subtitle}</p>
              <ul className="mt-6 flex-1 space-y-2 text-sm text-slate-700">
                {pro.features.map((f) => (
                  <li key={f} className="flex gap-2">
                    <span className="text-emerald-600">✓</span>
                    {f}
                  </li>
                ))}
              </ul>
              <Link to="/account?signup=1&plan=pro" className="mt-8 block">
                <button
                  type="button"
                  className="w-full rounded-xl bg-primary px-4 py-3 text-sm font-semibold text-white hover:bg-primary-dark"
                >
                  Create account for Pro
                </button>
              </Link>
            </div>
          </div>

          <div className="mt-12 rounded-2xl border border-slate-200 bg-white/80 p-6">
            <h3 className="text-sm font-semibold text-slate-900">Compare at a glance</h3>
            <div className="mt-4 overflow-x-auto">
              <table className="w-full min-w-[320px] text-left text-sm">
                <thead>
                  <tr className="border-b border-slate-200 text-slate-500">
                    <th className="py-2 pr-4 font-medium">Feature</th>
                    <th className="py-2 px-2 font-medium">Free</th>
                    <th className="py-2 px-2 font-medium">Pro</th>
                  </tr>
                </thead>
                <tbody>
                  {PLAN_COMPARISON.features.map((row) => (
                    <tr key={row.name} className="border-b border-slate-100 text-slate-700">
                      <td className="py-2 pr-4">{row.name}</td>
                      <td className="py-2 px-2">{row.free ? '✓' : '—'}</td>
                      <td className="py-2 px-2">{row.pro ? '✓' : '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Plans;
